export default "__VITE_ASSET__CCiDM9Vb__"